import React from "react";
import { SvgProps } from "../types";

export const FilterIcon = (props: SvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      className={props.classNames?.join(" ") || ""}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.15478 2.1549C2.46734 1.84234 2.89127 1.66675 3.33329 1.66675H16.6666C17.1087 1.66675 17.5326 1.84234 17.8451 2.1549C18.1577 2.46747 18.3333 2.89139 18.3333 3.33341V5.48841C18.3332 5.93036 18.1576 6.35436 17.8451 6.66684C17.845 6.66687 17.8451 6.66681 17.8451 6.66684L12.5 12.0118L12.5 14.1667C12.5 14.3878 12.4122 14.5997 12.2559 14.756L8.92255 18.0893C8.68422 18.3277 8.32579 18.399 8.01439 18.27C7.70299 18.141 7.49996 17.8371 7.49996 17.5001V12.0119L2.15496 6.66693C2.15493 6.6669 2.15499 6.66696 2.15496 6.66693C1.84243 6.35445 1.66672 5.93054 1.66663 5.48859V3.33341C1.66663 2.89139 1.84222 2.46746 2.15478 2.1549ZM16.6666 3.33341H3.33329V5.48824L8.67829 10.8332C8.67826 10.8332 8.67832 10.8333 8.67829 10.8332C8.99082 11.1457 9.16653 11.5696 9.16663 12.0116V15.4882L10.8333 13.8216V12.0117C10.8334 11.5698 11.009 11.1458 11.3215 10.8333C11.3215 10.8334 11.3216 10.8333 11.3215 10.8333L16.6665 5.48833L16.6666 3.33341Z"
      />
    </svg>
  );
};
